import script from "./Profile.vue?vue&type=script&setup=true&lang=js"
export * from "./Profile.vue?vue&type=script&setup=true&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=e359f034&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e359f034"]])

export default __exports__